namespace GeniuzPOS.Purchase {
    export enum CashOrTermfg {
        now = 0,
        term = 1
    }
    Serenity.Decorators.registerEnumType(CashOrTermfg, 'GeniuzPOS.Purchase.CashOrTermfg');
}
